import React from "react";
import { th } from "../../Shared/Styles";

export default function LapseTableRowHead(props) {
  if (props !== undefined) {
    return (
      <div>
          <thead>
            <tr>
              <th style={th}>Benefit Type</th>
              <th style={th}>StartDate</th>
              <th style={th}>Annual Premium</th>
              <th style={th}>Transaction Date</th>
              <th style={th}>Time in Force</th>
              <th style={th}>Date Out Of Force</th>
              <th style={th}>Lapse Description</th>
            </tr>
          </thead>
      </div>
    );
  }
}
